import { render, staticRenderFns } from "./trainingpracticalxq.vue?vue&type=template&id=ca1f5f08&scoped=true"
import script from "./trainingpracticalxq.vue?vue&type=script&lang=js"
export * from "./trainingpracticalxq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f5f08",
  null
  
)

export default component.exports